import { styled } from '@styles/stitches';

export const Radio = styled('div', {
  width: 20,
  height: 20,
  backgroundColor: '$primaryBorder',
  borderRadius: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Indicator = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 10,
  height: 10,
  borderRadius: 9999,
  backgroundColor: '$secondaryFill',
});

export const Container = styled('div', {
  display: 'flex',
  cursor: 'pointer',
  border: '1px solid $colors$primaryBorder',
  padding: '$space$3',
  borderRadius: 5,

  '&:hover': {
    border: '1px solid $colors$secondaryBorder',
  },

  '&:focus': {
    border: '1px solid $colors$secondaryFill',
    outline: 0,
  },
});
